/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_ObjectivesInputs */



/**
* | output |
* | --- |
* | "What you are practising" |
*
* @param {Practice_ObjectivesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_objectives = /** @type {((inputs?: Practice_ObjectivesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_ObjectivesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Waar je op oefent")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que vous travaillez")
	return /** @type {LocalizedString} */ ("What you are practising")
});